import { render, staticRenderFns } from "./OpenOrderList.vue?vue&type=template&id=014a52c4&"
import script from "./OpenOrderList.vue?vue&type=script&lang=js&"
export * from "./OpenOrderList.vue?vue&type=script&lang=js&"
import style0 from "./OpenOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports